import type { TradeLogicEditorContext } from '../tradeLogicNavigation';
import type { PublishAndAttachTradeLogicAuthoringDraftOutput, PublishTradeLogicAuthoringDraftOutput } from './types';

export interface DirectStrategyTradeLogicApplyTarget {
    mode: 'strategy';
    strategyId: number;
}

export interface PublishTradeLogicAuthoringDraftInContextResult {
    publishResult: PublishTradeLogicAuthoringDraftOutput | PublishAndAttachTradeLogicAuthoringDraftOutput;
    appliedToStrategy: boolean;
}

export const hasStrategyTradeLogicApplyTarget = (
    saveContext: TradeLogicEditorContext | null | undefined
): saveContext is DirectStrategyTradeLogicApplyTarget =>
    saveContext?.mode === 'strategy' &&
    typeof saveContext.strategyId === 'number' &&
    Number.isInteger(saveContext.strategyId) &&
    saveContext.strategyId > 0;
